import styled from "styled-components"

export const TestimonialCardWrapp = styled.div`
  .testimonial-card {
    min-width: 240px;
    background: #ffffff;
    border: 1px solid #e7e2d8;
    box-shadow: none;
    border-radius: 8px;
    padding: 18px;
    margin: 0;
    color: #28342f;

    .profile {
      display: flex;
      margin-bottom: 12px;

      .profile-name {
        margin: auto 0;
        .name {
          font-weight: 600;
          font-size: 15px;
          line-height: 1.4;
        }
        .role {
          font-weight: 500;
          font-size: 13px;
          line-height: 1.4;
          color: #69716b;
        }
      }
      .image-profile {
        margin-right: 12px;

        img {
          width: 38px;
          height: 38px;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }

    p {
      color: #4d5550;
      font-size: 13px;
      line-height: 1.55;
    }
  }
`
